import ReporteGeneral from '@pages/sistema/reporte/general';
import TicketList from '@pages/sistema/ticket';
import TicketView from '@pages/sistema/ticket/view.vue'

export default [
    {
        path: '/sistema/reporte',
        name: 'sistema.reporte.general',
        component: ReporteGeneral,
    },
    {
        path: '/sistema/ticket',
        name: 'sistema.ticket',
        component: TicketList,
    },
    {
        path: '/sistema/ticket/:id',
        name: 'sistema.ticket.view',
        component: TicketView,
    }
];
